import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { PatientListFilterModule } from '../components/patient-list-filter/patient-list-filter.module';
import { AuthGuard } from '../guards/auth.guard';
import { MatButtonModule} from '@angular/material/button';
import { VarModule } from '../directives/ngVar';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table'
import { MatPaginatorModule } from '@angular/material/paginator';
import {  MatTooltipModule } from '@angular/material/tooltip';
import { MatSortModule } from '@angular/material/sort';
import { MatDialogModule } from '@angular/material/dialog';
import { EditPatientDialogModule } from '../components/edit-patient-dialog/edit-patient-dialog.module';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { PatientsComponent } from './patients.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';



@NgModule({
  imports: [
    CommonModule,
    EditPatientDialogModule,
    MatButtonModule,
    MatDialogModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSortModule,
    MatTooltipModule,
    PatientListFilterModule,
    ReactiveFormsModule,
    VarModule,
    RouterModule.forChild([
      {
        path: 'patients',
        canActivate: [AuthGuard],
        component: PatientsComponent,
        children: []
      }
    ])
  ],
  declarations: [
    PatientsComponent
  ],
  exports: [
    PatientsComponent
  ]
})
export class PatientsModule { }
